'use strict';

const getSortedSkillItems = (items)=>{
    if (items.length <= 1) return items;
    return items.sort((a, b)=>{
        const specialRegex = /^[^a-zA-Z0-9가-힣]/; // 영어, 숫자, 한글이 아닌 모든 문자
        const numRegex = /^[0-9]/; // 숫자
        const engRegex = /^[A-Za-z]/; // 영어
        const korRegex = /^[가-힣]/; // 한글
        const getType = (value)=>{
            if (specialRegex.test(value)) return 0;
            if (numRegex.test(value)) return 1;
            if (engRegex.test(value)) return 2;
            if (korRegex.test(value)) return 3;
            return 4; // 그 외 경우
        };
        const typeA = getType(a.value);
        const typeB = getType(b.value);
        if (typeA !== typeB) {
            return typeA - typeB;
        }
        // 같은 유형일 경우 값에 따라 사전순 정렬
        return a.value.localeCompare(b.value);
    });
};

exports.getSortedSkillItems = getSortedSkillItems;
